module["exports"] = ["מדינת ישראל"];